import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCMG5QyS1HSW3PTbFq5KoFpSZ1hg7dGMTI",
  authDomain: "platforms-tech.firebaseapp.com",
  projectId: "platforms-tech",
  storageBucket: "platforms-tech.appspot.com",
  messagingSenderId: "117841179661",
  appId: "1:117841179661:web:6abe86167015d99e11d144",
};

export const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);

export const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: "select_account ",
});

export const auth = getAuth(app);

export const signInWithGooglePopup = () =>
  signInWithPopup(auth, googleProvider).catch((err) => alert(err.message));
